export default "__VITE_ASSET__44a2946d__"